/**
 * Deduplicate a locations array by name.
 * When multiple records share a name, keep the one with the most rooms
 * (falls back to the first occurrence if none have room_count).
 * Returns a sorted (A→Z) array of unique location objects.
 */
export function dedupeLocations(locations = []) {
  const best = new Map();
  for (const l of locations) {
    if (!l.name) continue;
    const existing = best.get(l.name);
    if (!existing || (l.room_count ?? 0) > (existing.room_count ?? 0)) {
      best.set(l.name, l);
    }
  }
  return [...best.values()].sort((a, b) => a.name.localeCompare(b.name));
}
